import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet';

import {
    MenuItem,
    Typography
} from "@material-ui/core";
import { Button } from "../../../common/components/libs";
import { useStores } from "../../../hooks";
import { observer } from "mobx-react";
import Wrapper from "../components/wrapper";
import { NavLink, Redirect, useParams } from "react-router-dom";
import { SnackbarType } from "../../../stores/common";
import logo from "../../../common/assets/logo_big.png";
import { trackSignUp } from "../../utils/MetrikaService";
import {Trans, useTranslation} from "react-i18next";


const SignUpAfterSignIn = () => {
    const {i18n, t} = useTranslation(["general", "auth"]);
    const { authStore, generalStore, constantsStore } = useStores();
    const { phone } = useParams<{ phone: string }>();

    console.log(phone);
    useEffect(() => {
        authStore.getCurrentUser().then(()=>{
            const locale =  authStore.organizationBranch?
                authStore.organizationBranch.data.defaultLocaleId:
                "ru";
            generalStore.setLocale({
                id: locale
            });
            const currencyNameId = authStore.organizationBranch?
                authStore.organizationBranch.data.defaultCurrencyId:
                "RUB";
            const currencyName = constantsStore.getLocalisedCurrencyName(currencyNameId);
            const currencyShortName = constantsStore.getLocalisedCurrencyShortName(currencyNameId);
            const currency = {id: currencyNameId, decimalPlaces: 2, currencyName: {[locale]: currencyName}, currencyShortName: {[locale]: currencyShortName}};
            generalStore.setCurrency(currency);
            i18n.changeLanguage(locale);
        })
    }, [authStore]);

    if (authStore.isAuthorized) {
        return <Redirect to="/"/>
    }

    const onSubmit = async () => {
        const phoneNumber = phone.replace(/\s/g, "");
        const isOk = await authStore.signUp(phoneNumber);
        if (!isOk) {
            generalStore.showSnackbar({
                type: SnackbarType.error,
                title: t("auth:errorWithCreationAccount"),
                description: t("auth:sureNoAccountForNumber")
            })
        }else{
            trackSignUp();
        }
    };

    return (
        <div>
            <Wrapper>
                <Helmet title={t("auth:registration")}/>

                <Typography component="h4" variant="h5" align="center" gutterBottom>
                    {t("auth:youHaveNotAccount")}
                </Typography>
                <Typography component="h4" variant="body2" align="center" gutterBottom>
                    {t("auth:createAccountAndStartSelling")}
                </Typography>
                <br/>
                <Typography component="h4" variant="body2" align="center" gutterBottom>
                    {t("auth:yourNumber")}
                </Typography>
                <Typography component="h2" variant="h4" align="center" gutterBottom>
                    {phone}
                </Typography>
                <br/>

                <form>
                    <Button
                        onClick={onSubmit}
                        fullWidth
                        variant="contained"
                        color="primary"
                        mb={2}
                    >
                        <span role='img'>🚀</span>
                        <span style={{display: 'inline-block', minWidth: 10}}/>
                        {t("auth:createAccount")}
                    </Button>
                    <Button
                        component={NavLink}
                        to="/auth/sign-in"
                        fullWidth
                        color="primary"
                    >
                        {t("general:back")}
                    </Button>
                </form>
            </Wrapper>
            <div style={{ textAlign: "center", marginTop: 20, marginLeft: -10 }}>
                <img src={logo} alt="" style={{ height: 20 }}/>
            </div>
        </div>
    );
};


export default observer(SignUpAfterSignIn)
